import { render, staticRenderFns } from "./foldertreenode.vue?vue&type=template&id=674ae7c4&scoped=true"
import script from "./foldertreenode.vue?vue&type=script&lang=ts"
export * from "./foldertreenode.vue?vue&type=script&lang=ts"
import style0 from "./foldertreenode.vue?vue&type=style&index=0&id=674ae7c4&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../.yarn/__virtual__/vue-loader-virtual-bcca2229bc/0/cache/vue-loader-npm-15.11.1-829412283a-509a816d45.zip/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674ae7c4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/src/.yarn/cache/vue-hot-reload-api-npm-2.3.4-549ae26337-9befc0b3d6.zip/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('674ae7c4')) {
      api.createRecord('674ae7c4', component.options)
    } else {
      api.reload('674ae7c4', component.options)
    }
    module.hot.accept("./foldertreenode.vue?vue&type=template&id=674ae7c4&scoped=true", function () {
      api.rerender('674ae7c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/foldertreenode.vue"
export default component.exports